
import { ElMessage } from "element-plus";
import { Saica } from "@/types/saica.type";
import { AppError } from "@/types/app.type";
import { defineComponent } from "@vue/runtime-core";
import { postSaica } from "@/service/saica.service";
import { Container } from "@/types/container.type";
import { SamplingPoint } from "@/types/samplingpoint.type";

const errorMessage = "error.required";

export default defineComponent({
  components: {},
  props: {
    id: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      saicaForm: {} as Saica,
      containersSaicas: [] as Container[],
      sampPointSaicas: [] as SamplingPoint[],
      containerId: null,
      rules: {
        name: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        code: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        river: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        utmX: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        utmY: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        timeZone: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        municipality: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        province: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        confederation: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
      },
    };
  },

  methods: {
    async doSave() {
      if (
        this.saicaForm.name === undefined ||
        this.saicaForm.code === undefined ||
        this.saicaForm.river === undefined ||
        this.saicaForm.utmX === undefined ||
        this.saicaForm.utmY === undefined ||
        this.saicaForm.timeZone === undefined ||
        this.saicaForm.municipality === undefined ||
        this.saicaForm.province === undefined ||
        this.saicaForm.confederation === undefined
      ) {
        ElMessage.error(this.$t(errorMessage));
        throw new Error(AppError.FORM_VALIDATION);
      }

      return postSaica(this.saicaForm);
    },
  },
});
